import React from 'react';
import { User, Mail, Phone, MapPin, Shield, Calendar, Award, Activity } from 'lucide-react';
export function ProfilePage() {
  return <div className="p-6 max-w-6xl mx-auto" data-id="element-414">
      <div className="mb-8" data-id="element-415">
        <h1 className="text-3xl font-bold text-white mb-2" data-id="element-416">User Profile</h1>
        <p className="text-gray-400" data-id="element-417">Manage your account and credentials</p>
      </div>

      <div className="grid grid-cols-3 gap-6" data-id="element-418">
        {/* Left Column: Profile Card */}
        <div className="col-span-1" data-id="element-419">
          <div className="bg-gray-800 rounded-xl border border-gray-700 p-6" data-id="element-420">
            <div className="flex flex-col items-center text-center" data-id="element-421">
              <div className="w-24 h-24 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center mb-4" data-id="element-422">
                <User className="w-12 h-12 text-white" data-id="element-423" />
              </div>
              <h2 className="text-2xl font-bold text-white mb-1" data-id="element-424">
                Sarah Jenkins
              </h2>
              <p className="text-blue-400 font-medium mb-4" data-id="element-425">Scrub Nurse</p>

              <div className="w-full space-y-3 mt-6" data-id="element-426">
                <div className="flex items-center gap-3 text-sm" data-id="element-427">
                  <Mail className="w-4 h-4 text-gray-400" data-id="element-428" />
                  <span className="text-gray-300" data-id="element-429">
                    sarah.jenkins@hospital.org
                  </span>
                </div>
                <div className="flex items-center gap-3 text-sm" data-id="element-430">
                  <Phone className="w-4 h-4 text-gray-400" data-id="element-431" />
                  <span className="text-gray-300" data-id="element-432">+1 (555) 123-4567</span>
                </div>
                <div className="flex items-center gap-3 text-sm" data-id="element-433">
                  <MapPin className="w-4 h-4 text-gray-400" data-id="element-434" />
                  <span className="text-gray-300" data-id="element-435">OR Wing, Floor 3</span>
                </div>
              </div>

              <button className="w-full mt-6 px-4 py-2.5 bg-blue-600 hover:bg-blue-500 text-white rounded-lg font-medium transition-colors" data-id="element-436">
                Edit Profile
              </button>
            </div>
          </div>

          {/* Certifications */}
          <div className="bg-gray-800 rounded-xl border border-gray-700 p-6 mt-6" data-id="element-437">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-438">
              <Award className="w-5 h-5 text-yellow-400" data-id="element-439" />
              Certifications
            </h3>
            <div className="space-y-3" data-id="element-440">
              <div className="flex items-center justify-between p-3 bg-gray-900 rounded-lg" data-id="element-441">
                <div data-id="element-442">
                  <div className="text-sm font-medium text-white" data-id="element-443">
                    RN License
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-444">Exp: Dec 2025</div>
                </div>
                <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-445"></div>
              </div>
              <div className="flex items-center justify-between p-3 bg-gray-900 rounded-lg" data-id="element-446">
                <div data-id="element-447">
                  <div className="text-sm font-medium text-white" data-id="element-448">CNOR</div>
                  <div className="text-xs text-gray-400" data-id="element-449">Exp: Jun 2024</div>
                </div>
                <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-450"></div>
              </div>
              <div className="flex items-center justify-between p-3 bg-gray-900 rounded-lg" data-id="element-451">
                <div data-id="element-452">
                  <div className="text-sm font-medium text-white" data-id="element-453">BLS</div>
                  <div className="text-xs text-gray-400" data-id="element-454">Exp: Mar 2024</div>
                </div>
                <div className="w-2 h-2 bg-yellow-500 rounded-full" data-id="element-455"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Details & Stats */}
        <div className="col-span-2 space-y-6" data-id="element-456">
          {/* Account Details */}
          <div className="bg-gray-800 rounded-xl border border-gray-700 p-6" data-id="element-457">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center gap-2" data-id="element-458">
              <Shield className="w-5 h-5 text-blue-400" data-id="element-459" />
              Account Details
            </h3>
            <div className="grid grid-cols-2 gap-6" data-id="element-460">
              <div data-id="element-461">
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-462">
                  Employee ID
                </label>
                <div className="text-white font-mono" data-id="element-463">EMP-2847</div>
              </div>
              <div data-id="element-464">
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-465">
                  Department
                </label>
                <div className="text-white" data-id="element-466">Surgical Services</div>
              </div>
              <div data-id="element-467">
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-468">
                  Role
                </label>
                <div className="text-white" data-id="element-469">Scrub Nurse</div>
              </div>
              <div data-id="element-470">
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-471">
                  Access Level
                </label>
                <div className="text-white" data-id="element-472">Standard User</div>
              </div>
              <div data-id="element-473">
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-474">
                  Hire Date
                </label>
                <div className="text-white" data-id="element-475">Jan 15, 2019</div>
              </div>
              <div data-id="element-476">
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-477">
                  Last Login
                </label>
                <div className="text-white" data-id="element-478">Today, 7:42 AM</div>
              </div>
            </div>
          </div>

          {/* Activity Stats */}
          <div className="bg-gray-800 rounded-xl border border-gray-700 p-6" data-id="element-479">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center gap-2" data-id="element-480">
              <Activity className="w-5 h-5 text-green-400" data-id="element-481" />
              Activity Summary (Last 30 Days)
            </h3>
            <div className="grid grid-cols-3 gap-6" data-id="element-482">
              <div className="bg-gray-900 p-4 rounded-xl" data-id="element-483">
                <div className="text-gray-400 text-sm mb-1" data-id="element-484">
                  Cases Completed
                </div>
                <div className="text-3xl font-bold text-white" data-id="element-485">42</div>
                <div className="text-xs text-green-400 mt-1" data-id="element-486">
                  +8 vs last month
                </div>
              </div>
              <div className="bg-gray-900 p-4 rounded-xl" data-id="element-487">
                <div className="text-gray-400 text-sm mb-1" data-id="element-488">Avg Case Time</div>
                <div className="text-3xl font-bold text-white" data-id="element-489">48m</div>
                <div className="text-xs text-blue-400 mt-1" data-id="element-490">
                  -5m improvement
                </div>
              </div>
              <div className="bg-gray-900 p-4 rounded-xl" data-id="element-491">
                <div className="text-gray-400 text-sm mb-1" data-id="element-492">Overrides</div>
                <div className="text-3xl font-bold text-white" data-id="element-493">2</div>
                <div className="text-xs text-gray-400 mt-1" data-id="element-494">4.8% of cases</div>
              </div>
            </div>
          </div>

          {/* Recent Activity */}
          <div className="bg-gray-800 rounded-xl border border-gray-700 p-6" data-id="element-495">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-496">
              <Calendar className="w-5 h-5 text-purple-400" data-id="element-497" />
              Recent Activity
            </h3>
            <div className="space-y-3" data-id="element-498">
              <div className="flex items-center gap-4 p-3 bg-gray-900 rounded-lg" data-id="element-499">
                <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-500"></div>
                <div className="flex-1" data-id="element-501">
                  <div className="text-sm font-medium text-white" data-id="element-502">
                    Completed Case #SRG-9902
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-503">
                    Today at 2:30 PM • OR Room 4
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-4 p-3 bg-gray-900 rounded-lg" data-id="element-504">
                <div className="w-2 h-2 bg-blue-500 rounded-full" data-id="element-505"></div>
                <div className="flex-1" data-id="element-506">
                  <div className="text-sm font-medium text-white" data-id="element-507">
                    Logged into system
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-508">Today at 7:42 AM</div>
                </div>
              </div>
              <div className="flex items-center gap-4 p-3 bg-gray-900 rounded-lg" data-id="element-509">
                <div className="w-2 h-2 bg-yellow-500 rounded-full" data-id="element-510"></div>
                <div className="flex-1" data-id="element-511">
                  <div className="text-sm font-medium text-white" data-id="element-512">
                    Manual override on Case #SRG-9898
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-513">
                    Yesterday at 4:15 PM • OR Room 3
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}